module.exports = __webpack_public_path__ + "static/side-bubble-db778590dd3fcfecd1ac725d719cbddc.png";